module.exports = __webpack_public_path__ + "img/shape.3d50a0d9.webp";